import { render, staticRenderFns } from "./user-roles.vue?vue&type=template&id=5a89f90e&scoped=true"
import script from "./user-roles.vue?vue&type=script&lang=js"
export * from "./user-roles.vue?vue&type=script&lang=js"
import style0 from "./user-roles.vue?vue&type=style&index=0&id=5a89f90e&prod&lang=scss&scoped=true"
import style1 from "./user-roles.vue?vue&type=style&index=1&id=5a89f90e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a89f90e",
  null
  
)

export default component.exports